<template>
    <TransitionGroup
        tag="div"
        enter-active-class="transition-all duration-300 ease-out"
        enter-from-class="-translate-y-full opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="absolute transition-all duration-300 ease-out"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-full opacity-0"
    >
        <slot />
    </TransitionGroup>
</template>
